import styled from "styled-components";

export const SectionTitle = styled("h2")`
  margin: 32px 0px 16px 0px;
  font-size: 18px;
  font-weight: normal;
`;
